module.exports = __webpack_public_path__ + "static/media/Woodlegs_Portrait.b1fa9893.png";